import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/base/LoadingState";

import { CatalogueCleanupNotice } from "@/pages/products/components/CatalogueCleanupNotice";

export function AppShell({ children }: { children: ReactNode }) {
  const { sidebarOpen } = useApp();
  const { pathname } = useLocation();
  const { loading, user, org } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <LoadingState />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar />
      <div
        className={`flex-1 min-w-0 flex flex-col transition-all duration-300 ${
          sidebarOpen ? "lg:ml-64" : "lg:ml-20"
        }`}
      >
        <TopBar />
        {/* The document scrolls long pages. Keep only bounded panels/drawers as
            nested scroll containers; main expands with its content. */}
        <main className="flex-1 min-w-0 p-4 md:p-6 lg:p-8">
          {pathname.startsWith("/products") && <CatalogueCleanupNotice key={`${org?.id ?? "none"}:${pathname}`} />}
          {children}
        </main>
      </div>
    </div>
  );
}
